import Pager from "@kopapro/components/commons/pager/pager";

export default Pager;